// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-023f2846]{box-sizing:border-box;display:flex;flex-direction:column;justify-content:space-between;width:180px;height:146px;padding:16px 0 16px 12px;font-size:12px;font-weight:400;color:#333;list-style:disc inside;background:#fff;border-radius:4px;opacity:.8}", ""]);
// Exports
module.exports = exports;
